import { DecisionTreeRoutingModule } from './decision-tree-routing.module';
import { EsoService } from './../eso.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxRangeSelectorModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DecisionTreeComponent } from './decision-tree.component';


@NgModule({
  declarations: [DecisionTreeComponent],
  imports: [
    CommonModule,
    DecisionTreeRoutingModule,
    DxDataGridModule,
    DxChartModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule,
    DxChartModule,
    DxTextAreaModule,
    DxRangeSelectorModule,
    DxDataGridModule,
    DevEpressCommonModule
  ],
  providers: [EsoService]
})
export class DecisionTreeModule { }
